module.exports = __webpack_public_path__ + "static/media/podcast-header-background.a862c190.png";